export default "__VITE_ASSET__CUKgQ_jK__"